import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';

import { actions as reqSocialChannel } from '../../../redux/board/reqSocialChannel';
import { isDesktop } from '../../../utils/mobileHelpers';
import { ACTIONS } from '../../../constants/strings';
import Button from '../../Button';

const ConversationBtnImpl = ({ intl: { formatMessage }, userId }) => {
  const dispatch = useDispatch();
  const handleStartConversation = useCallback(() => {
    dispatch(reqSocialChannel.send({ participants: [userId] }));
  }, [userId]);

  return (
    <Button
      raised
      type="button"
      onClick={handleStartConversation}
      color="primary"
      className={!isDesktop() ? 'mt3' : null}
    >
      {formatMessage(ACTIONS.chat.sendMessage)}
    </Button>
  );
};

const propTypes = {
  userId: PropTypes.number.isRequired,
};

export const ConversationBtn = compose(injectIntl)(ConversationBtnImpl);

ConversationBtnImpl.propTypes = { ...propTypes };
ConversationBtn.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ConversationBtn/index.jsx